import React from "react";
import { generateTime } from "Services/Time";
import { ReviewItemBReply } from "ComponentsUI/Reviews";
import { webpSimpleTransformer, webpTransformer } from "Helpers/ImageManager";

export default class ReviewItemBReplyContainer extends React.Component {
	render() {
		let date = !this.props.stub ? generateTime(this.props.date) : null;
		return (
			<ReviewItemBReply
				{...this.props}
				logo={!!this.props.logo ? this.props.logo : ""}
				webpTransformer={webpSimpleTransformer}
				date={date}
			/>
		);
	}
}
